import './Checkbox.css'
import cx from 'classnames'

export function Checkbox({
  id,
  checked,
  className,
  onChange,
  disabled
}: {
  id: string
  checked: boolean
  className?: string
  onChange: (checked: boolean) => void
  disabled?: boolean
}) {
  return (
    <input
      checked={checked}
      id={id}
      disabled={disabled}
      type="checkbox"
      value=""
      onChange={event => onChange(event.target.checked)}
      className={cx('peer', 'checkbox-base', 'checkbox-checked', 'checkbox-disabled', className)}
    />
  )
}
